import _ from "lodash";
import {
  SET_SENDER_DETAILS,
  SET_RECIVER_DETAILS,
  SHOW_LOADER,
  HIDE_LOADER,
  NEW_ADDRESS_DETAILS,
  SET_USER_DETAILS,
  SET_BUSINESS_LIST,
  SET_SELECTED_BUSINESS,
} from "../actions/actionConstants";
import { REHYDRATE } from "redux-persist";

const initialState = {
  user_details: {},
  is_loading: false,
  sender_details: {},
  reciver_details: {},
  new_address_details: {},
  business_accounts: [],
  selected_business_id: null,
  selected_business_account: {},
};

const app = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE: {
      return {
        ...state,
        ...(action.payload?.app || {}),
        is_loading: false,
      };
    }
    case SET_USER_DETAILS: {
      return {
        ...state,
        user_details: action?.data,
      };
    }

    case SHOW_LOADER:
      return { ...state, is_loading: true };
    case HIDE_LOADER:
      return { ...state, is_loading: false };

    case SET_SENDER_DETAILS: {
      return { ...state, sender_details: action?.data };
    }

    case SET_RECIVER_DETAILS: {
      return { ...state, reciver_details: action?.data };
    }

    case NEW_ADDRESS_DETAILS: {
      return { ...state, new_address_details: action?.data };
    }
    case SET_BUSINESS_LIST: {
      return { ...state, business_accounts: action?.data };
    }
    case SET_SELECTED_BUSINESS: {
      return {
        ...state,
        selected_business_account: action.data,
        selected_business_id: action.data?.business_id,
      };
    }
    default:
      return state;
  }
};

export default app;
